<template>
  <WdsTooltip :text="fullDate" top>
    <time :datetime="isoDate">{{ timeAgo }}</time>
  </WdsTooltip>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsTooltip } from '@worksome/wds-components'
import useDate from '@/composables/useDate'
import { useLocaleTimeAgo } from '@/composables/useLocaleTimeAgo'

const props = defineProps<{
  date: string | Date
}>()

const date = computed(() => props.date)
const timeAgo = useLocaleTimeAgo(date, { withAgo: true })
const { date: fullDate } = useDate(date, 'lll')
const isoDate = computed(() => new Date(props.date).toISOString())
</script>
